import React, { useState, useRef, useEffect } from 'react';
import ReactDom from 'react-dom';
import classnames from 'classnames';
import { Placement } from 'swag-client-common/constants';
import { getFileExtension } from 'swag-client-common/utils/get-file-extension';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import classes from './file-name.scss';
export const FileName = ({
  name: fullName,
  className
}) => {
  const [isTooltipAvailable, setTooltipAvailability] = useState(false);
  const measureRef = useRef(null);
  const containerRef = useRef(null);
  const {
    name,
    extension
  } = getFileExtension(fullName);
  useEffect(() => {
    var _measureRef$current$c, _measureRef$current, _containerRef$current, _containerRef$current2;
    const measureWidth = (_measureRef$current$c = (_measureRef$current = measureRef.current) === null || _measureRef$current === void 0 ? void 0 : _measureRef$current.clientWidth) !== null && _measureRef$current$c !== void 0 ? _measureRef$current$c : 0;
    const containerWidth = (_containerRef$current = (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.clientWidth) !== null && _containerRef$current !== void 0 ? _containerRef$current : 0;
    if (measureWidth && containerWidth) {
      setTooltipAvailability(measureWidth > containerWidth);
    }
  }, [fullName]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    className: className,
    title: isTooltipAvailable ? fullName : '',
    mode: "light",
    placement: Placement.BOTTOM
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container,
    ref: containerRef
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.fileName
  }, name), /*#__PURE__*/React.createElement("span", {
    className: classes.fileExtension
  }, extension))), /*#__PURE__*/ReactDom.createPortal( /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.container, classes.measure),
    ref: measureRef
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.fileName
  }, name), /*#__PURE__*/React.createElement("span", {
    className: classes.fileExtension
  }, extension)), document.body));
};